import { WlcmQueryParams } from '@wlcm/common';

export const DEFAULT_SEARCH_PARAMS: WlcmQueryParams = {
  query: '',
  page: 1,
  limit: 10,
};
